<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Select a cart</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <div class="list-group list-group-light">
        <ng-container *ngFor="let cart of carts; let i = index">
            <button type="button" class="list-group-item list-group-item-action px-3 border-0" (click)="selectCart(cart)">
                {{cart.cartName}}
                <span class="float-end">
                    <i class="fas fa-cart-plus"></i>
                </span>
            </button>

        </ng-container>
        <button
            type="button" class="list-group-item list-group-item-action px-3 border-0"
            (click)="basicCollapse.toggle()"
            [attr.aria-expanded]="!basicCollapse.collapsed"
            aria-controls="collapseExample"
            >
            <i class="fas fa-plus me-2"></i> New cart
        </button>
            <div class="add-cart-dropdown" id="collapseExample" mdbCollapse #basicCollapse="mdbCollapse">
                <div>Cart name</div>
                <input class="new-cart-input w-100" type="text" placeholder="Add a name..." [(ngModel)]="cartName">
                <div class="mt-2">
                    <span class="cart-cancel me-2" (click)="basicCollapse.hide()">Cancel</span>
                    <button class="cart-add" (click)="addNewCart()">Continue</button>
                </div>
            </div>
    </div>

</div>
<!-- <div class="custom-accordion">
        <ng-container *ngFor="let cart of carts; let i = index">
            <div class="accordion-item" >
                <div class="accordion-header">
                    <div class="row">
                        <div class="col-10" (click)="addDesignToCart(cart)">
                            <div class="accordion-title">{{ cart.cartName }}</div>
                            <span>{{cart.designs.length}} {{cart.designs.length === 1 ?
                                'design' : 'designs'}}</span>
                        </div>
                        <ng-container
                            *ngIf="cart">
                            <div
                                class="col-2 d-flex align-items-center justify-content-center" (click)="addDesignToCart(cart)">
                                <span class="accordion-icon">
                                    <i class="fas fa-plus"></i>
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="accordion-item">
            <div class="accordion-header">
                <div *ngIf="!showNewCartInput" class="accordion-title"
                    (click)="toggleNewCartInput($event)">
                    <i class="fas fa-plus me-2"></i> New cart
                </div>
                <div *ngIf="showNewCartInput">
                    <div>Cart name</div>
                    <input class="new-cart-input w-100" type="text"
                        placeholder="Add a name..." [(ngModel)]="form.cartName">
                    <div class="mt-2">
                        <span class="cart-cancel me-2"
                            (click)="toggleNewCartInput($event)">Cancel</span>
                        <button class="cart-add" (click)="addNewCart()">Continue</button>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
<!-- </div> -->